import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PhxBottomSheetBodyDirective } from './phx-bottom-sheet-body.directive';
import { PhxBottomSheetComponent } from './phx-bottom-sheet.component';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxSheetModule } from '../sheet/phx-sheet.module';

@NgModule({
  imports: [CommonModule, PhxIconButtonModule, PhxSheetModule],
  declarations: [PhxBottomSheetComponent, PhxBottomSheetBodyDirective],
  exports: [PhxBottomSheetComponent, PhxBottomSheetBodyDirective],
})
export class PhxBottomSheetModule {}
